import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "tamr-icon-more-vert",
  "use": "tamr-icon-more-vert-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"tamr-icon-more-vert\"><circle id=\"tamr-icon-more-vert_Oval\" cx=\"8\" cy=\"3\" r=\"1.5\" /><circle id=\"tamr-icon-more-vert_Oval-Copy\" cx=\"8\" cy=\"13\" r=\"1.5\" /><circle id=\"tamr-icon-more-vert_Oval-Copy-2\" cx=\"8\" cy=\"8\" r=\"1.5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol